import WorkExperienceHeading from './WorkExperienceHeading';

export default function WorkExperienceForm({ person, onClose }) {
    return (
        <div className="main-person-form-container">
            <WorkExperienceHeading person={person} onClose={onClose} />
        </div>
    );

 
}